/**
 * Takes number and return string in Swedish format with
 * spaces as thousand separators and commas for decimals separator
 * @param 11342.82
 * @returns '11 342,82'
 */
export const swedishNumberFormatter = (x?: number) => {
  if (x === undefined) {
    return '-';
  }
  // Ensure that we always have two decimals, if x has decimals (x % 1 !== 0)
  // x = 1245 => 1245
  // x = 1245.2 => 1245.20
  // x = 1245.25 => 1245.25
  const numberHasDecimals = x % 1 !== 0;
  const formattedNumber = x.toLocaleString('sv-SE', {
    minimumFractionDigits: numberHasDecimals ? 2 : 0,
    maximumFractionDigits: numberHasDecimals ? 2 : 0,
  });

  return formattedNumber;
};
